<app-spinner [loading]="creating() || loadingCryptotokenKeys() || loadingCsr() || importingCertChain()"></app-spinner>
<form [formGroup]="form" class="create-ca" appFormFields>
  <h1 class="create-ca__title">{{title()}}</h1>
  <div class="create-ca__body">
    <div class="create-ca__inputs">
      <app-form-field [name]="CaFormField.subjectDn" class="create-ca__subjectdn"></app-form-field>
      <div class="create-ca__tokenname-group">
        <app-form-field [name]="CaFormField.tokenName" [options]="cryptotokens()"></app-form-field>
        <app-form-field [name]="CaFormField.signKey" [options]="validCryptotokenKeys()"></app-form-field>
        <app-form-field [name]="CaFormField.signingAlgo" [options]="signingAlgos"></app-form-field>
      </div>
      <div class="create-ca__signedby-group" [class.create-ca__signedby-group--edit]="edit()">
        <app-form-field class="create-ca__signedby" [name]="CaFormField.signedBy" [options]="caNamesWithExternal()"></app-form-field>
        @if(!edit()) {
          <app-form-field [name]="CaFormField.profileName" [options]="profileNames()" [disabledTooltipText]="labels.disabledProfileTooltip"></app-form-field>
        }
      </div>
      <div class="create-ca__location">
        <app-form-field [name]="CaFormField.validityUnits"></app-form-field>
        @switch (form.value[CaFormField.validityUnits]) {
          @case (ValidityUnit.day) {
            <app-form-field [name]="CaFormField.validityDays"></app-form-field>
          }
          @case (ValidityUnit.year) {
            <app-form-field [name]="CaFormField.validityYears"></app-form-field>
          }
          @default {
            <app-form-field [name]="CaFormField.validityDays"></app-form-field>
          }
        }
        <app-form-field [name]="CaFormField.expirationDate" [errorStateMatcher]="expirationErrorStateMatcher"></app-form-field>
      </div>
      <app-form-field [name]="CaFormField.defaultCRLDistPoint"></app-form-field>
      <app-form-field [name]="CaFormField.defaultOCSPServiceLocator"></app-form-field>
      <app-form-field [name]="CaFormField.useLdapDnOrder"></app-form-field>
    </div>
    @if(canUseCsr() && csr()) {
      <div class="create-ca__csr">
        <h2 class="create-ca__csr-title">CSR</h2>
        <app-monospaced-block>{{csr()}}</app-monospaced-block>
        </div>
    }
    @if(canImportCertChain()) {
      <div class="create-ca__certchain">
        <mat-form-field appearance="outline" class="create-ca__certchain-field">
        <mat-label>Cert chain</mat-label>
        <textarea matInput [rows]="5" [formControlName]="CaFormField.certChain"></textarea>
        </mat-form-field>
        <button [disabled]="importedCertChain() || !form.controls[CaFormField.certChain].value" type="button" mat-button class="button" (click)="onImportCertChain()">{{labels.buttons.importCertChain}}</button>
      </div>
    }
    <div class="create-ca__buttons">
      <button type="button" mat-button class="button" (click)="onCancel()">{{labels.buttons.cancel}}</button>
      @if(canUseCsr()) {
        <button type="button" mat-button class="button" (click)="onCsrRequest()" [disabled]="!!csr()">
          {{labels.buttons.createCsr}}
        </button>
      }
      @if(edit()) {
        <button type="submit" mat-button class="button button_primary" (click)="onSubmitEdited()">{{labels.buttons.update}}</button>
      }
      @else {
        <button type="submit" mat-button class="button button_primary" (click)="onSubmit()">{{labels.buttons.create}}</button>
      }
    </div>
  </div>
</form>
